import {ChangeDetectionStrategy, ChangeDetectorRef, Component,
  CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import {FACET_PUBLISHER, FacetSearchService, RELEVANCE} from '@app/services/facet-search.service';
import {DcpVendorJson, JsonService, SlmTransactionType, Vendor} from '@dcp/configurator';
import {UntilDestroy} from '@ngneat/until-destroy';
import {CurrentProductService, MediaComponent} from '@spartacus/storefront';
import {DcpProductUtilitiesService} from '../../services/dcp-product-utilities.service';
import {NavigationLink} from '../navigation-bar/navigation-link';
import {ProductDetailsNavigationLinkService} from '../navigation-bar/product-details-navigation-link.service';
import {ProductDetailsSectionComponent} from '../product-details-section/product-details-section.component';
import {LimitedTextComponent} from '../../../shared/limited-text/limited-text.component';
import {CtaFormComponent} from '../../cta-form/cta-form.component';
import {TranslatePipe} from '@spartacus/core';
import {ProductPageDecoratorService} from '@app/product/services/product-page-decorator.service';

// Used by ProductSupportWidgetComponent to look up the publisher's commercial
// model config and label its analytics events. Not used by this component
// directly any more — kept here because removing it would require moving the
// constant and updating support-widget's import.
export const PARTNER_SLM_TRANSACTION_TYPE: SlmTransactionType = {
  code: 'LEAD_RFI',
  name: 'Contact Publisher',
  label: 'productDetails.cta.rfi',
};

@UntilDestroy()
@Component({
  selector: 'dcp-default-publisher',
  templateUrl: './publisher.component.html',
  styleUrls: ['./publisher.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MediaComponent, LimitedTextComponent, CtaFormComponent, TranslatePipe],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class PublisherComponent extends ProductDetailsSectionComponent {
  vendor: Vendor;
  logo: string;
  hasLogo = false;
  name: string;
  code: string;
  description: string;
  website: string;
  navLink: NavigationLink = {
    headline: 'productDetails.publisher',
    id: 'publisher-section',
  };

  constructor(
    private facetSearchService: FacetSearchService,
    currentProductService: CurrentProductService,
    changeDetection: ChangeDetectorRef,
    navigationLinkService: ProductDetailsNavigationLinkService,
    private jsonService: JsonService,
    dcpProductUtilitiesService: DcpProductUtilitiesService,
    protected productPageDecoratorService: ProductPageDecoratorService,
  ) {
    super(currentProductService, changeDetection, navigationLinkService, dcpProductUtilitiesService, productPageDecoratorService);
  }

  isVisible(): boolean {
    return !!this.vendor;
  }

  openPublisherSolutions(publisherName: string): void {
    this.facetSearchService.searchByFacet(RELEVANCE + FACET_PUBLISHER, publisherName);
  }

  openPublisherSolutionsWithKeyboard(publisherName: string, event: KeyboardEvent): void {
    if (event.key === 'Enter') {
      this.openPublisherSolutions(publisherName);
    }
  }

  prepareData(): void {
    if (!this.product) {
      return;
    }
    this.vendor = this.product.vendor;
    if (!this.vendor) {
      return;
    }
    this.hasLogo = !!this.vendor.logo?.[0];
    this.logo = this.vendor.logo?.[0]?.url;
    this.name = this.vendor.name;
    this.code = this.vendor.code;
    this.website = this.vendor.website;
    const json = this.findAttribute('description');
    this.description = json?.description?.trim() ? json.description : this.vendor.description;
  }

  private findAttribute(entryType: string): DcpVendorJson {
    const rawAttr = this.vendor.json?.find((entry) => entry.type === entryType);
    return rawAttr ? (this.jsonService.parseSafely(rawAttr.value) as DcpVendorJson) : undefined;
  }
}
